import type { JSX, ReactNode } from 'react';

export interface FormSectionProps {
  title: string;
  children: ReactNode;
}

/**
 * A titled group of fields laid out in a responsive 2-column grid.
 * Long fields (notes, address blocks, multi-checkbox groups) span both
 * columns via `sm:col-span-2` on their own wrapper, not on this component.
 */
export function FormSection({ title, children }: FormSectionProps): JSX.Element {
  return (
    // A <legend> sits outside the fieldset's flex/grid flow and ignores `gap`,
    // so its spacing lives on the legend itself.
    <fieldset className="min-w-0">
      <legend className="mb-4 w-full border-b border-slate-100 pb-2 text-xs font-semibold uppercase tracking-wide text-primary-700">
        {title}
      </legend>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">{children}</div>
    </fieldset>
  );
}
